import { render, staticRenderFns } from "./FailReasonDataNew.vue?vue&type=template&id=77d9a1e7&scoped=true&"
import script from "./FailReasonDataNew.vue?vue&type=script&lang=js&"
export * from "./FailReasonDataNew.vue?vue&type=script&lang=js&"
import style0 from "./FailReasonDataNew.vue?vue&type=style&index=0&id=77d9a1e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d9a1e7",
  null
  
)

export default component.exports